module.exports = __webpack_public_path__ + "img/cv_transition_active.596434cc.png";